// extracted by mini-css-extract-plugin
module.exports = {"truncate":"truncate-iF2oF","small":"small-EC8Tl","semibold":"semibold-m2LdP","normal":"normal-F8CkD"};